import React, { useEffect, useState } from "react";
import Select from "react-select";
import axios from "axios";

const DepartmentSelect = ({ value, onChange }) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);



  useEffect(() => {
    const fetchDepartments = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/departments/listdepartment`, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });
        const transformedDepartments = response.data.map((department) => ({
          value: department.id,
          label: department.department,
        }));
        setDepartments(transformedDepartments);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching departments:", error.message);
        setLoading(false);
      }
    };

    fetchDepartments();
  }, []);

  const handleChange = (selectedOption) => {
    onChange(selectedOption);
  };

    // Custom styles for the Select component
    const customStyles = {
      control: (provided) => ({
        ...provided,
        backgroundColor: '#f9f9f9', // Apply background color
        borderColor: '#ddd', // Apply border color
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: 9999, // Ensure dropdown appears above other elements
      }),
      placeholder: (provided) => ({
        ...provided,
        color: '#666666', // Customize placeholder color
      }),
    };

  return (
    <Select
      options={departments}
      placeholder="Select Department"
      value={value ? departments.find(option => option.value === value.value) || null : null}
      onChange={handleChange}
      isLoading={loading}
      styles={customStyles} // Apply custom styles here
      isClearable
    />
  );
};

export default DepartmentSelect;
